import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav from '@components/tabNav';
import FeedbackList from '@components/feedbackList';
import { px2rem } from '@utils/px2rem';

interface MyFeedbackListH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    feedbackList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navClick?: Function
    feedbackFilterIndex?: number
}
interface MyFeedbackListH5State {
    loading: boolean;
    error: any
    pageLoaded: any
}
@inject('app', 'site', 'user', 'thread')
@observer
class MyFeedbackListH5Page extends BasePage<MyFeedbackListH5PageProps, MyFeedbackListH5State> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };
    componentDidMount() {
        super.componentDidMount();
    }

    handleGoSetFeedbackPost = () => {
        window.globalEnsureLogin(() => {
            this.props.history.push('/setFeedbackPost');
        });
    }

    // 反馈列表
    renderFeedbackList = () => {
        const { thread, feedbackList, loading, hasMore, onLoadMore, navList, navCurrentIndex, navClick } = this.props;
        if (!thread || !thread.listStore) return null;

        return (
            <div className={styles.feedbackContent}>
                <div className={styles.filterBox}>
                    <TabNav
                        navList={navList}
                        currentIndex={navCurrentIndex}
                        navClick={(item: any, index: number) => {
                            navClick && navClick(item, index);
                        }}
                    />
                </div>
                <div style={{ marginBottom: 16 }}>
                    <FeedbackList
                        data={feedbackList || []}
                        loading={loading || false}
                        hasMore={hasMore ?? true}
                        emptyText="这里是空的~"
                        emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                        emptyBoxStyle={{ padding: `${px2rem(200)} 0 ${px2rem(240)}` }}
                        emptyExtra={(
                            <div className={styles.emptyFeedbackBtn} onClick={this.handleGoSetFeedbackPost}>
                                我要反馈
                            </div>
                        )}
                        namespace="usersFeedbacksList"
                        onLoadMore={onLoadMore}
                        listStore={thread.listStore}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (<div className={styles.wrapper}>
            {this.renderFeedbackList()}
        </div>)
    }
}

export default withRouter(MyFeedbackListH5Page);
